import type React from 'react';

import { button, buttonText } from './ButtonLink.css';

interface ButtonLinkHref {
  href?: string;
  children: React.ReactNode;
  size?: 'small' | 'medium';
  onClick?: (e: React.MouseEvent) => void;
}

type ButtonLinkProps = ButtonLinkHref;

export const ButtonLink = ({
  children,
  href = '#',
  onClick,
  size = 'medium',
}: ButtonLinkProps) => (
  <a href={href} onClick={onClick} className={button[size]}>
    <p className={buttonText}>{children}</p>
  </a>
);
